/* eslint-disable no-prototype-builtins, perfectionist/sort-objects */

/**
 * This client was automatically generated by RudderTyper. ** Do Not Edit **
 *
 * The default handler that is fired if none is supplied with setRudderTyperOptions.
 * This handler will log a warning message to the console.
 */
export const defaultValidationErrorHandler = (message, violations) => {
  const msg = JSON.stringify(
    {
      type: 'RudderTyper JSON Schema Validation Error',
      description:
        `You made an analytics call (${message.event}) using RudderTyper that doesn't match the ` +
        'Tracking Plan spec.',
      errors: violations,
    },
    undefined,
    2,
  );
  console.warn(msg);
};
let analytics = () => {
  return window.analytics;
};
/**
 * User completed the account creation process
 *
 * @param {AccountCreationCompleted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function accountCreationCompleted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Account Creation Completed', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User initiated the account creation process
 *
 * @param {AccountCreationStarted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function accountCreationStarted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Account Creation Started', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * Generic CTA click events
 *
 * @param {CallToActionClicked} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function callToActionClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Call to Action Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User selects a size on an upsell in the cart
 *
 * @param {CartUpsellSizeSelected} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function cartUpsellSizeSelected(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Cart Upsell Size Selected', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User clicks on an upsell swatch in the cart
 *
 * @param {CartUpsellSwatchClicked} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function cartUpsellSwatchClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Cart Upsell Swatch Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User viewed their shopping cart
 *
 * @param {CartViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function cartViewed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Cart Viewed', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User hit a failure scenario during checkout
 *
 * @param {CheckoutFailure} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checkoutFailure(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Checkout Failure', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User initiated the order process (a transaction is created)
 *
 * @param {CheckoutStarted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checkoutStarted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Checkout Started', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User completed a checkout step
 *
 * @param {CheckoutStepCompleted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checkoutStepCompleted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Checkout Step Completed', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User viewed a checkout step
 *
 * @param {CheckoutStepViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function checkoutStepViewed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Checkout Step Viewed', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User opened the product details accordion
 *
 * @param {DetailsAccordionOpened} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function detailsAccordionOpened(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Details Accordion Opened', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * App user clicked Discover card
 *
 * @param {DiscoverClicked} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function discoverClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Discover Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * App user viewed Discover card
 *
 * @param {DiscoverViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function discoverViewed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Discover Viewed', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User views an experiment on a page
 *
 * @param {ExperimentViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function experimentViewed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Experiment Viewed', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User clicked a link within the footer
 *
 * @param {FooterLinkClicked} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function footerLinkClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Footer Link Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User clicks on the gift message option in the cart
 *
 * @param {Record<string, any>} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function giftMessageClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Gift Message Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User submits a gift message option in the cart
 *
 * @param {GiftMessageSubmitted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function giftMessageSubmitted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Gift Message Submitted', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User clicked a link within the global banner
 *
 * @param {GlobalBannerLinkClicked} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function globalBannerLinkClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Global Banner Link Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User clicked on the homepage hero
 *
 * @param {HomepageHeroClicked} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function homepageHeroClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Homepage Hero Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User clicked on a homepage module (ie carousel card, secondary hero)
 *
 * @param {HomepageModuleClicked} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function homepageModuleClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Homepage Module Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User clicked on the mini navigation
 *
 * @param {MiniNavigationClicked} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function miniNavigationClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Mini Navigation Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User clicked on a navigation level
 *
 * @param {NavigationClicked} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function navigationClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Navigation Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User viewed a navigation level
 *
 * @param {NavigationViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function navigationViewed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Navigation Viewed', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User completed the order
 *
 * @param {OrderCompleted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function orderCompleted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Order Completed', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User clicked on a PDP module
 *
 * @param {PdpModuleClicked} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function pdpModuleClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('PDP Module Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User added a product to their shopping cart
 *
 * @param {ProductAdded} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productAdded(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Product Added', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User clicked on a product
 *
 * @param {ProductClicked} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Product Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User clicked on a product image
 *
 * @param {ProductImageClicked} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productImageClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Product Image Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User scrolled through a product image
 *
 * @param {ProductImageScroll} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productImageScroll(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Product Image Scroll', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User clicked a Collection card
 *
 * @param {ProductListClicked} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productListClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Product List Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User clicked a collection feature (ie banner, toggle)
 *
 * @param {ProductListFeatureClicked} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productListFeatureClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Product List Feature Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * @typedef ProductListFilteredFiltersItem
 * @property {string} type -
 * @property {string} value -
 */
/**
 * @typedef ProductListFilteredProductsItem
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {string} [silhouette] -
 * @property {string} [sku] -
 * @property {string} [url] -
 */
/**
 * @typedef ProductListFilteredSortsItem
 * @property {string} type -
 * @property {string} value -
 */
/**
 * @typedef ProductListFiltered
 * @property {string} collection_handle -
 * @property {string} collection_name -
 * @property {string} collection_parent -
 * @property {string} collection_type -
 * @property {string} [collection_url] -
 * @property {string} currency -
 * @property {string} currency_symbol -
 * @property {ProductListFilteredFiltersItem[]} [filters] -
 * @property {boolean} [is_markdown_collection] -
 * @property {string} list_id -
 * @property {ProductListFilteredProductsItem[]} products -
 * @property {ProductListFilteredSortsItem[]} [sorts] -
 */
/**
 * @typedef ProductViewed
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {boolean} [initial_load] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {string} [silhouette] -
 * @property {string} [sku] -
 * @property {string} [url] -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef ReviewsStarsClickedProductsItem
 * @property {string} category -
 * @property {string} gender -
 * @property {string} name -
 * @property {number} [review_rating] -
 */
/**
 * @typedef ReviewsStarsClicked
 * @property {ReviewsStarsClickedProductsItem[]} products -
 */
/**
 * @typedef ProductClickedProductsItem
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {string} [silhouette] -
 * @property {string} [sku] -
 * @property {string} [url] -
 */
/**
 * @typedef ProductClicked
 * @property {string} collection_handle -
 * @property {string} collection_name -
 * @property {string} collection_parent -
 * @property {string} collection_type -
 * @property {string} [collection_url] -
 * @property {string} currency -
 * @property {string} currency_symbol -
 * @property {ProductClickedProductsItem[]} products -
 */
/**
 * @typedef UserMarketingPreference
 * @property {string} [cms_product_id] -
 * @property {string} message_medium -
 * @property {string} message_type -
 * @property {boolean} opt_in_status -
 * @property {string} placement -
 * @property {string} [purpose] -
 * @property {string} [sku] -
 */
/**
 * @typedef CheckoutStepCompletedProductsItem
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} variant_id -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef CheckoutStepCompleted
 * @property {string} checkout_id -
 * @property {string} [checkout_url] -
 * @property {string} [coupon] -
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {number} [discount] -
 * @property {string} [payment_method] -
 * @property {string} [payment_method_selected] -
 * @property {CheckoutStepCompletedProductsItem[]} [products] -
 * @property {number} [shipping] -
 * @property {string} [shipping_method] -
 * @property {number} [step] -
 * @property {string} step_name -
 * @property {number} [subtotal] -
 * @property {number} [tax] -
 * @property {number} [total] -
 * @property {string} [type] -
 */
/**
 * @typedef CartViewedProductsItem
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef CartViewed
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {CartViewedProductsItem[]} products -
 */
/**
 * @typedef ProductListViewedProductsItem
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {string} [silhouette] -
 * @property {string} [sku] -
 * @property {string} [url] -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef ProductListViewed
 * @property {string} collection_handle -
 * @property {string} collection_name -
 * @property {string} collection_parent -
 * @property {number} collection_style_count -
 * @property {string} collection_type -
 * @property {string} [collection_url] -
 * @property {string} currency -
 * @property {string} currency_symbol -
 * @property {boolean} [is_markdown_collection] -
 * @property {string} list_id -
 * @property {ProductListViewedProductsItem[]} products -
 */
/**
 * @typedef ProductShared
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {string} [share_via] -
 * @property {string} [silhouette] -
 * @property {string} [sku] -
 * @property {string} [url] -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef ExperimentViewed
 * @property {string} campaign_id -
 * @property {string} campaign_name -
 * @property {string} experience_id -
 * @property {string} experience_name -
 * @property {string} experiment_type -
 * @property {string} variation_id -
 * @property {string} variation_name -
 * @property {string} [web_platform] -
 */
/**
 * @typedef ProductAddedProductsItem
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} variant_id -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef ProductAdded
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {ProductAddedProductsItem[]} [products] -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} variant_id -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef CheckoutStartedProductsItem
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} variant_id -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef CheckoutStarted
 * @property {string} checkout_id -
 * @property {string} checkout_url -
 * @property {string} [coupon] -
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {number} [discount] -
 * @property {string} [order_id] -
 * @property {CheckoutStartedProductsItem[]} products -
 * @property {number} [revenue] -
 * @property {number} [shipping] -
 * @property {number} [tax] -
 * @property {number} [total] -
 * @property {string} [type] -
 * @property {number} [value] -
 */
/**
 * @typedef OrderCompletedProductsItem
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} [variant_id] -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef OrderCompleted
 * @property {number} [campaignId] -
 * @property {string} [checkout_id] -
 * @property {string} [checkout_url] -
 * @property {string} [coupon] -
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {number} [discount] -
 * @property {string} order_id -
 * @property {string} [order_name] -
 * @property {string} [payment_method] -
 * @property {string} [payment_method_selected] -
 * @property {OrderCompletedProductsItem[]} products -
 * @property {number} [revenue] -
 * @property {number} [shipping] -
 * @property {string} [shipping_method] -
 * @property {number} [subtotal] -
 * @property {number} [tax] -
 * @property {number} [templateId] -
 * @property {number} [total] -
 * @property {string} [type] -
 * @property {number} [value] -
 */
/**
 * @typedef ProductListFeatureClicked
 * @property {string} collection_handle -
 * @property {string} collection_name -
 * @property {string} [collection_parent] -
 * @property {number} [collection_style_count] -
 * @property {string} [collection_type] -
 * @property {string} collection_url -
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {string} [feature_cta] -
 * @property {string} [feature_link_destination] -
 * @property {string} feature_type -
 * @property {boolean} [is_markdown_collection] -
 * @property {string} list_id -
 */
/**
 * @typedef ProductRemovedProductsItem
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} variant_id -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef ProductRemoved
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {ProductRemovedProductsItem[]} [products] -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} variant_id -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef CheckoutStepViewedProductsItem
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} variant_id -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef CheckoutStepViewed
 * @property {string} checkout_id -
 * @property {string} [checkout_url] -
 * @property {string} [coupon] -
 * @property {string} [currency] -
 * @property {string} [currency_symbol] -
 * @property {number} [discount] -
 * @property {string} [payment_method] -
 * @property {string} [payment_method_selected] -
 * @property {CheckoutStepViewedProductsItem[]} [products] -
 * @property {number} [shipping] -
 * @property {string} [shipping_method] -
 * @property {number} [step] -
 * @property {string} step_name -
 * @property {number} [subtotal] -
 * @property {number} [tax] -
 * @property {number} [total] -
 * @property {string} [type] -
 */
/**
 * @typedef MiniNavigationClicked
 * @property {string} [link_CTA_name] -
 * @property {string} link_destination -
 */
/**
 * @typedef CheckoutFailureProductsItem
 * @property {string} [cart_added_trigger_source] -
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {number} [quantity] -
 * @property {string} [silhouette] -
 * @property {string} sku -
 * @property {string} [url] -
 * @property {string} variant_id -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef CheckoutFailure
 * @property {string} checkout_id -
 * @property {string} [checkout_url] -
 * @property {string} failure_reason -
 * @property {string} [payment_method] -
 * @property {string} [payment_method_selected] -
 * @property {CheckoutFailureProductsItem[]} [products] -
 * @property {string} [shipping_method] -
 * @property {string} [type] -
 */
/**
 * @typedef PushNotificationTapped
 * @property {string} utm_campaign -
 * @property {string} [utm_medium] -
 * @property {string} [utm_source] -
 */
/**
 * @typedef HomepageHeroClicked
 * @property {string} [image_name] -
 * @property {string} [link_CTA_name] -
 * @property {string} link_destination -
 */
/**
 * @typedef CallToActionClicked
 * @property {string} [campaign_name] -
 * @property {string} [copy] -
 * @property {string} [experience_name] -
 * @property {string} location -
 * @property {string} name -
 * @property {string} type -
 * @property {string} [url] -
 * @property {number} [value] -
 * @property {number} [variation_id] -
 * @property {string} [variation_name] -
 */
/**
 * @typedef HomepageModuleClicked
 * @property {string} [carousel_card_name] -
 * @property {number} [carousel_card_position] -
 * @property {string} [carousel_category_name] -
 * @property {string} [image_name] -
 * @property {string} [link_CTA_name] -
 * @property {string} [link_destination] -
 * @property {string} module_name -
 * @property {number} module_position -
 * @property {string} module_type -
 */
/**
 * @typedef AccountCreationCompleted
 * @property {string} account_creation_date -
 * @property {string} sign_up_source -
 * @property {boolean} [subscribed_to_marketing] -
 */
/**
 * @typedef FooterLinkClicked
 * @property {string} footer_link_category -
 * @property {string} footer_link_name -
 */
/**
 * @typedef GlobalBannerLinkClicked
 * @property {string} global_banner_name -
 * @property {string} global_header_source -
 */
/**
 * @typedef ProductsSearched
 * @property {number} [number_of_search_results] -
 * @property {string} query -
 * @property {string} [search_entry] -
 * @property {string} [search_source] -
 */
/**
 * @typedef AccountCreationStarted
 * @property {string} sign_up_source -
 * @property {string} [sign_up_source_page] -
 */
/**
 * @typedef NavigationViewed
 * @property {string} [navigation_level_1] -
 * @property {string} [navigation_level_2] -
 * @property {string} [navigation_level_3] -
 * @property {string} [navigation_source] -
 * @property {string} navigation_type -
 */
/**
 * @typedef NavigationClicked
 * @property {string} [navigation_level_1] -
 * @property {string} [navigation_level_2] -
 * @property {string} [navigation_level_3] -
 * @property {string} [navigation_source] -
 * @property {string} navigation_type -
 */
/**
 * @typedef ProductsSearchInitiated
 * @property {string} [search_entry] -
 * @property {string} search_source -
 */
/**
 * @typedef ReviewsSortedProductsItem
 * @property {string} category -
 * @property {string} gender -
 * @property {string} name -
 * @property {number} [review_rating] -
 */
/**
 * @typedef ReviewsSorted
 * @property {ReviewsSortedProductsItem[]} products -
 * @property {string} [search_sort] -
 */
/**
 * @typedef ReviewsSearchedProductsItem
 * @property {string} category -
 * @property {string} gender -
 * @property {string} name -
 * @property {number} [review_rating] -
 */
/**
 * @typedef ReviewsSearched
 * @property {ReviewsSearchedProductsItem[]} products -
 * @property {string} [search_keyword] -
 */
/**
 * @typedef DiscoverViewedDiscoverCardsItem
 * @property {string} name -
 * @property {number} position -
 */
/**
 * @typedef DiscoverViewed
 * @property {DiscoverViewedDiscoverCardsItem[]} discover_cards -
 */
/**
 * @typedef DiscoverClickedDiscoverCardsItem
 * @property {string} [action] -
 * @property {string} name -
 * @property {number} position -
 */
/**
 * @typedef DiscoverClicked
 * @property {DiscoverClickedDiscoverCardsItem[]} discover_cards -
 */
/**
 * @typedef ProductImageScrollProductsItem
 * @property {string} category -
 * @property {string} gender -
 * @property {string} name -
 */
/**
 * @typedef ProductImageScroll
 * @property {number} pdp_image_position -
 * @property {ProductImageScrollProductsItem[]} products -
 */
/**
 * @typedef GiftMessageSubmitted
 * @property {boolean} logo_free -
 */
/**
 * @typedef ProductListClickedProductsItem
 * @property {string} [category] -
 * @property {string} [color_name] -
 * @property {number} [compare_at_price] -
 * @property {string} [edition] -
 * @property {string} [gender] -
 * @property {string} handle -
 * @property {string} [hue] -
 * @property {string} [image_url] -
 * @property {string} [kit_id] -
 * @property {string} [material] -
 * @property {string} [name] -
 * @property {boolean} [on_sale] -
 * @property {number} [position] -
 * @property {number} [price] -
 * @property {string} [price_tier] -
 * @property {string} product_id -
 * @property {string} [silhouette] -
 * @property {string} [sku] -
 * @property {string} [url] -
 * @property {string} [variant_title] -
 * @property {string} [variant_url] -
 */
/**
 * @typedef ProductListClicked
 * @property {string} collection_handle -
 * @property {string} collection_name -
 * @property {string} collection_parent -
 * @property {number} collection_style_count -
 * @property {string} collection_type -
 * @property {string} collection_url -
 * @property {string} currency -
 * @property {string} currency_symbol -
 * @property {boolean} [is_markdown_collection] -
 * @property {string} list_id -
 * @property {ProductListClickedProductsItem[]} products -
 */
/**
 * @typedef ProductImageClickedProductsItem
 * @property {string} category -
 * @property {string} gender -
 * @property {string} handle -
 * @property {string} name -
 * @property {string} product_id -
 */
/**
 * @typedef ProductImageClicked
 * @property {number} pdp_image_position -
 * @property {ProductImageClickedProductsItem[]} products -
 */
/**
 * @typedef SizeSelectorClickedProductsItem
 * @property {string} category -
 * @property {string} [color_name] -
 * @property {string} gender -
 * @property {string} name -
 * @property {string} [sku] -
 * @property {string} [variant_id] -
 * @property {string} [variant_title] -
 */
/**
 * @typedef SizeSelectorClicked
 * @property {boolean} [in_stock] -
 * @property {boolean} [is_default] -
 * @property {SizeSelectorClickedProductsItem[]} products -
 */
/**
 * @typedef DetailsAccordionOpenedProductsItem
 * @property {string} category -
 * @property {string} gender -
 * @property {string} name -
 */
/**
 * @typedef DetailsAccordionOpened
 * @property {string} [accordion_opened] -
 * @property {DetailsAccordionOpenedProductsItem[]} products -
 */
/**
 * @typedef SizeGuideOpenedProductsItem
 * @property {string} category -
 * @property {string} gender -
 * @property {string} name -
 */
/**
 * @typedef SizeGuideOpened
 * @property {SizeGuideOpenedProductsItem[]} products -
 */
/**
 * @typedef ReviewsLoadMoreProductsItem
 * @property {string} category -
 * @property {string} gender -
 * @property {string} name -
 * @property {number} [review_rating] -
 */
/**
 * @typedef ReviewsLoadMore
 * @property {ReviewsLoadMoreProductsItem[]} products -
 */
/**
 * @typedef ReviewsFilteredProductsItem
 * @property {string} category -
 * @property {string} gender -
 * @property {string} name -
 * @property {number} [review_rating] -
 */
/**
 * @typedef ReviewsFiltered
 * @property {string} [filters_applied] -
 * @property {ReviewsFilteredProductsItem[]} products -
 * @property {string} [search_filter_activity] -
 * @property {string} [search_filter_activity_level] -
 * @property {string} [search_filter_fit] -
 * @property {string} [search_filter_height] -
 * @property {string} [search_filter_overall_fit] -
 * @property {string} [search_filter_size_purchased] -
 * @property {number} [search_filter_star_rating] -
 * @property {string} [search_filter_typical_size] -
 * @property {string} [search_filter_typical_width] -
 */
/**
 * @typedef RecommendationsClickedProductsItem
 * @property {string} category -
 * @property {string} gender -
 * @property {string} [handle] -
 * @property {string} name -
 * @property {string} [product_id] -
 */
/**
 * @typedef RecommendationsClicked
 * @property {string} campaign_id -
 * @property {string} campaign_name -
 * @property {number} carousel_card_position -
 * @property {string} experience_id -
 * @property {string} experience_name -
 * @property {RecommendationsClickedProductsItem[]} products -
 * @property {string} [recommendation_heading] -
 * @property {string} [source_page] -
 * @property {string} [source_url] -
 * @property {string} variation_id -
 * @property {string} variation_name -
 */
/**
 * @typedef CartUpsellSizeSelectedProductsItem
 * @property {string} category -
 * @property {string} [color_name] -
 * @property {string} gender -
 * @property {string} name -
 * @property {string} sku -
 */
/**
 * @typedef CartUpsellSizeSelected
 * @property {boolean} [in_stock] -
 * @property {CartUpsellSizeSelectedProductsItem[]} products -
 */
/**
 * @typedef CartUpsellSwatchClickedProductsItem
 * @property {string} category -
 * @property {string} [color_name] -
 * @property {string} gender -
 * @property {string} name -
 * @property {string} [sku] -
 */
/**
 * @typedef CartUpsellSwatchClicked
 * @property {CartUpsellSwatchClickedProductsItem[]} products -
 */
/**
 * @typedef PdpModuleClicked
 * @property {string} [card_name] -
 * @property {number} [card_position] -
 * @property {string} [image_name] -
 * @property {string} [link_CTA_name] -
 * @property {string} [link_destination] -
 * @property {string} module_name -
 * @property {number} module_position -
 * @property {string} module_type -
 */
/**
 * User filtered a collection
 *
 * @param {ProductListFiltered} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productListFiltered(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Product List Filtered', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User viewed a collection
 *
 * @param {ProductListViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productListViewed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Product List Viewed', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User removed a product from their shopping cart
 *
 * @param {ProductRemoved} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productRemoved(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Product Removed', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * Shared a product with one or more friends
 *
 * @param {ProductShared} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productShared(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Product Shared', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User did a text search for products
 *
 * @param {ProductsSearched} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productsSearched(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Products Searched', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User clicked on the search icon or in the search field
 *
 * @param {ProductsSearchInitiated} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productsSearchInitiated(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Products Search Initiated', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User viewed a product details
 *
 * @param {ProductViewed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function productViewed(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Product Viewed', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User taps on a push notification
 *
 * @param {PushNotificationTapped} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function pushNotificationTapped(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Push Notification Tapped', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User clicks on a product recommendation
 *
 * @param {RecommendationsClicked} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function recommendationsClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Recommendations Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User filtered the product reviews
 *
 * @param {ReviewsFiltered} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function reviewsFiltered(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Reviews Filtered', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User loads more reviews
 *
 * @param {ReviewsLoadMore} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function reviewsLoadMore(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Reviews Load More', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User searches through a product's reviews
 *
 * @param {ReviewsSearched} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function reviewsSearched(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Reviews Searched', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User sorts a product's reviews
 *
 * @param {ReviewsSorted} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function reviewsSorted(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Reviews Sorted', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User clicked on the product reviews stars
 *
 * @param {ReviewsStarsClicked} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function reviewsStarsClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Reviews Stars Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * Updates the run-time configuration of this RudderTyper client.
 *
 * @param {RudderTyperOptions} options - the options to upsert
 *
 * @typedef {Object} RudderTyperOptions
 * @property {Rudder.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
export function setRudderTyperOptions(options) {
  analytics = options.analytics ? () => options.analytics || window.analytics : analytics;
}
/**
 * User opened the product size guide
 *
 * @param {SizeGuideOpened} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sizeGuideOpened(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Size Guide Opened', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User clicked on the size selector
 *
 * @param {SizeSelectorClicked} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function sizeSelectorClicked(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('Size Selector Clicked', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * User preferences for opting into/out marketing messages
 *
 * @param {UserMarketingPreference} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
 * 		call is fired.
 */
export function userMarketingPreference(props, options, callback) {
  const a = analytics();
  if (a) {
    a.track('User Marketing Preference', props || {}, withRudderTyperContext(options), callback);
  }
}
/**
 * Helper to attach metadata on RudderTyper to outbound requests.
 * This is used for attribution and debugging by the RudderStack team.
 */
function withRudderTyperContext(message = {}) {
  return {
    ...message,
    context: {
      ...(message.context || {}),
      ruddertyper: {
        sdk: 'analytics.js',
        language: 'javascript',
        rudderTyperVersion: '1.0.0-beta.5',
        trackingPlanId: 'tp_1uZ45DFhpGdImHhzH0baIm3XHCJ',
        trackingPlanVersion: '103',
      },
    },
  };
}
const clientAPI = {
  /**
   * Updates the run-time configuration of this RudderTyper client.
   *
   * @param {RudderTyperOptions} options - the options to upsert
   *
   * @typedef {Object} RudderTyperOptions
   * @property {Rudder.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
   * 		calls are forwarded on to. Defaults to window.analytics.
   * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
   * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
   * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
   * 		will be logged to stderr.
   */
  setRudderTyperOptions,
  /**
   * User filtered a collection
   *
   * @param {ProductListFiltered} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productListFiltered,
  /**
   * User viewed a product details
   *
   * @param {ProductViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productViewed,
  /**
   * User clicked on the product reviews stars
   *
   * @param {ReviewsStarsClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  reviewsStarsClicked,
  /**
   * User clicked on a product
   *
   * @param {ProductClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productClicked,
  /**
   * User preferences for opting into/out marketing messages
   *
   * @param {UserMarketingPreference} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  userMarketingPreference,
  /**
   * User completed a checkout step
   *
   * @param {CheckoutStepCompleted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  checkoutStepCompleted,
  /**
   * User viewed their shopping cart
   *
   * @param {CartViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  cartViewed,
  /**
   * User viewed a collection
   *
   * @param {ProductListViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productListViewed,
  /**
   * Shared a product with one or more friends
   *
   * @param {ProductShared} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productShared,
  /**
   * User views an experiment on a page
   *
   * @param {ExperimentViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  experimentViewed,
  /**
   * User added a product to their shopping cart
   *
   * @param {ProductAdded} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productAdded,
  /**
   * User initiated the order process (a transaction is created)
   *
   * @param {CheckoutStarted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  checkoutStarted,
  /**
   * User completed the order
   *
   * @param {OrderCompleted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  orderCompleted,
  /**
   * User clicked a collection feature (ie banner, toggle)
   *
   * @param {ProductListFeatureClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productListFeatureClicked,
  /**
   * User removed a product from their shopping cart
   *
   * @param {ProductRemoved} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productRemoved,
  /**
   * User viewed a checkout step
   *
   * @param {CheckoutStepViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  checkoutStepViewed,
  /**
   * User clicked on the mini navigation
   *
   * @param {MiniNavigationClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  miniNavigationClicked,
  /**
   * User hit a failure scenario during checkout
   *
   * @param {CheckoutFailure} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  checkoutFailure,
  /**
   * User taps on a push notification
   *
   * @param {PushNotificationTapped} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  pushNotificationTapped,
  /**
   * User clicked on the homepage hero
   *
   * @param {HomepageHeroClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  homepageHeroClicked,
  /**
   * Generic CTA click events
   *
   * @param {CallToActionClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  callToActionClicked,
  /**
   * User clicked on a homepage module (ie carousel card, secondary hero)
   *
   * @param {HomepageModuleClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  homepageModuleClicked,
  /**
   * User completed the account creation process
   *
   * @param {AccountCreationCompleted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  accountCreationCompleted,
  /**
   * User clicked a link within the footer
   *
   * @param {FooterLinkClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  footerLinkClicked,
  /**
   * User clicked a link within the global banner
   *
   * @param {GlobalBannerLinkClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  globalBannerLinkClicked,
  /**
   * User did a text search for products
   *
   * @param {ProductsSearched} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productsSearched,
  /**
   * User initiated the account creation process
   *
   * @param {AccountCreationStarted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  accountCreationStarted,
  /**
   * User viewed a navigation level
   *
   * @param {NavigationViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  navigationViewed,
  /**
   * User clicked on a navigation level
   *
   * @param {NavigationClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  navigationClicked,
  /**
   * User clicked on the search icon or in the search field
   *
   * @param {ProductsSearchInitiated} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productsSearchInitiated,
  /**
   * User sorts a product's reviews
   *
   * @param {ReviewsSorted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  reviewsSorted,
  /**
   * User searches through a product's reviews
   *
   * @param {ReviewsSearched} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  reviewsSearched,
  /**
   * App user viewed Discover card
   *
   * @param {DiscoverViewed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  discoverViewed,
  /**
   * App user clicked Discover card
   *
   * @param {DiscoverClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  discoverClicked,
  /**
   * User scrolled through a product image
   *
   * @param {ProductImageScroll} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productImageScroll,
  /**
   * User submits a gift message option in the cart
   *
   * @param {GiftMessageSubmitted} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  giftMessageSubmitted,
  /**
   * User clicked a Collection card
   *
   * @param {ProductListClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productListClicked,
  /**
   * User clicked on a product image
   *
   * @param {ProductImageClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  productImageClicked,
  /**
   * User clicked on the size selector
   *
   * @param {SizeSelectorClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  sizeSelectorClicked,
  /**
   * User opened the product details accordion
   *
   * @param {DetailsAccordionOpened} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  detailsAccordionOpened,
  /**
   * User opened the product size guide
   *
   * @param {SizeGuideOpened} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  sizeGuideOpened,
  /**
   * User loads more reviews
   *
   * @param {ReviewsLoadMore} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  reviewsLoadMore,
  /**
   * User clicks on the gift message option in the cart
   *
   * @param {Record<string, any>} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  giftMessageClicked,
  /**
   * User filtered the product reviews
   *
   * @param {ReviewsFiltered} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  reviewsFiltered,
  /**
   * User clicks on a product recommendation
   *
   * @param {RecommendationsClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  recommendationsClicked,
  /**
   * User selects a size on an upsell in the cart
   *
   * @param {CartUpsellSizeSelected} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  cartUpsellSizeSelected,
  /**
   * User clicks on an upsell swatch in the cart
   *
   * @param {CartUpsellSwatchClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  cartUpsellSwatchClicked,
  /**
   * User clicked on a PDP module
   *
   * @param {PdpModuleClicked} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   * @param {Function} [callback] - An optional callback called after a short timeout after the analytics
   * 		call is fired.
   */
  pdpModuleClicked,
};
export default new Proxy(clientAPI, {
  get(target, method) {
    if (typeof method === 'string' && target.hasOwnProperty(method)) {
      return target[method];
    }
    return () => {
      console.warn(`⚠️  You made an analytics call (${String(method)}) that can't be found. Either:
    a) Re-generate your ruddertyper client: \`npx rudder-typer\`
    b) Add it to your Tracking Plan: https://api.rudderstack.com/trackingplans/tp_1uZ45DFhpGdImHhzH0baIm3XHCJ`);
      const a = analytics();
      if (a) {
        a.track(
          'Unknown Analytics Call Fired',
          {
            method,
          },
          withRudderTyperContext(),
        );
      }
    };
  },
});
